import React from 'react';

export default function HideButton({item, itemId, hideItem}) {
  const onClick = (evt) => {
    evt.preventDefault();
    hideItem(itemId || item?.id);
  }

  return (
    <a className="cursor-pointer text-gray-400" onClick={onClick}>
      <span className="fa fa-lg fa-times"/>
      {' '}
      Remove
    </a>
  );
}
